import Vue from 'vue';
import Router from 'vue-router';

import GridView from '@/views/GridView';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'overview',
      component: GridView,
    },
  ],
});
